import {
  BaseEvent,
  BasePlugin,
  BaseStats,
  createErrorReportEvent,
  EventLevel,
  mergePluginOption,
} from '@fpkg/stats-core';
import { base64Encode } from '@fpkg/stats-utils';

/**
 * 顺丰云日志插件配置项，error级别的事件才上报顺丰云
 */
export interface SFLogsOpt {
  // 上报地址
  logUrl?: string;
  encode?: boolean;
}

export default class SFLogsPlugin implements BasePlugin {
  name = 'sflogs';

  stats?: BaseStats;

  option: SFLogsOpt = {
    logUrl: '', // 上传到顺丰云日志接口
    encode: false, // 是否加密上报
  };

  constructor(option: SFLogsOpt | null | boolean) {
    mergePluginOption(this.option, option);
  }

  reportCatchError(error: any) {
    // 捕获异常，确保不影响其他上报流程
    console.error('上报顺丰云日志报错', error);
    // 上报神策
    this.stats?.customError({
      event: 'StatsError',
      event_code: 'ReportSFLogsError',
      event_name: '上报顺丰云日志报错',
      plugin_name: this.name,
      error,
    });
  }

  setup(stats: BaseStats): void {
    this.stats = stats;

    if (!this.option.logUrl) {
      return;
    }

    this.stats.on('beforeSend', (eventInfo: any) => {
      this.sendSf(eventInfo);
      return eventInfo;
    });
  }

  /**
   * 上报到顺丰云日志请求
   * @param eventInfo
   */
  sendSf(eventInfo: BaseEvent) {
    const newEventInfo = createErrorReportEvent(eventInfo, this.stats!.commonParams);
    // 上传当前页面路径到顺丰云日志
    if (!newEventInfo.$url) {
      newEventInfo.$url = window.location.href;
    }

    if (newEventInfo.event_level === EventLevel.ERROR) {
      // 上报到顺丰云日志
      try {
        let data: any = newEventInfo;
        let header: any = {
          'Content-Type': 'application/json',
        };

        // 加密上报
        if (this.option.encode) {
          data = `msg=${encodeURIComponent(base64Encode(JSON.stringify(newEventInfo), true))}`;
          header = {
            'Content-Type': 'application/x-www-form-urlencoded',
          };
        }
        this.stats?.sender
          .request({
            url: this.option.logUrl!,
            method: 'post',
            header,
            data,
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {
        console.error(err);
      }
    }
  }
}
